export const defaultLabels = {
	a11yToggleNotifications: "Toggle notifications: {{ active }} active alerts",
	a11yCloseMenu: "Close notifications",
	a11yOpenLiveRegion: 'Showing "{{ filter }}" notifications',
	a11yClosedLiveRegion: "Notifications are hidden",
	a11yMenu: "Notification categories",
	a11yList: "Notifications list",
	noResultsAll: "There are no notifications to display.",
	noResultsAlert: "There are no alerts to display.",
	noResultsOffer: "There are no offers to display.",
	menuHeadingAll: "All",
	menuHeadingAlert: "Alerts",
	menuHeadingOffer: "Offers",
	menuTitleAll: "All notifications",
	menuTitleAlert: "All alerts",
	menuTitleOffer: "All offers",
	menuViewAlert: "View all travel alerts",
	menuViewOffer: "View all deals",
};
